// src/services/aiAgentsApi.ts — AI Agents page: MCP connections, the agent
// activity trail, and deployments an agent started. All existing backend
// routes; the backend scopes each one to the signed-in user.
import { apiClient } from './apiClient';

export interface AgentConnection {
    client_id: string;
    client_name: string;
    logo_uri?: string | null;
    connected_at: string;
    last_used_at: string | null;
    scope: string | null;
}

export interface AgentActivityEntry {
    occurred_at: string;
    client_id: string | null;
    client_name: string | null;
    tool: string;
    service_id: string | null;
    outcome: 'preview' | 'success' | 'denied' | 'error' | string;
    args: { app_id?: string; name?: string; service_type?: string; branch?: string; deployment_id?: string; tier?: string };
    reason: string | null;
    duration_ms: number | null;
}

export interface AgentDeployment {
    id: string;
    status: string;
    createdAt: string;
    startedAt: string | null;
    completedAt: string | null;
    source: 'upload' | 'git';
    app: { id: number; uuid: string | null; name: string; type: string; status: string };
    liveUrl: string | null;
}

export const aiAgentsApi = {
    getAgentConnections: (): Promise<{ success: boolean; connections: AgentConnection[] }> =>
        apiClient.get('/oauth/connections'),
    // The backend revokes every MCP grant for the account; there is no per-client revoke.
    disconnectAllAgents: (): Promise<{ success: boolean; message: string }> =>
        apiClient.del('/oauth/connections'),
    getAgentActivity: (limit = 50): Promise<{ success: boolean; entries: AgentActivityEntry[] }> =>
        apiClient.get(`/oauth/audit?limit=${limit}`),
    getRecentAgentDeployments: (): Promise<{ deployments: AgentDeployment[] }> =>
        apiClient.get('/deployments/agent-recent'),
};
